import   React               ,
       { useEffect           ,
         useState}  from "react";

import   classNames             from 'classnames';

import   styles                 from './CustomerFrontEventList.module.scss';

import   TabularDisplay         from "../../widget/dataDisplay/tables/TabularDisplay";

import   CartesianGraph         from "../../widget/dataDisplay/charts/CartesianGraph";
import   OpenStreetMap          from "../../widget/dataDisplay/maps/OpenStreetMap";
import   ExtendablePanel        from "../../widget/windows/ExtendablePanel";
import   DateTimeRangePicker    from "../../widget/inputs/DateTimeRangePicker";
import   WidgetFrame            from '../../widget/navigation/WidgetFrame';
import   Select                 from '../../widget/inputs/Select';
import   Field                  from "../../widget/inputs/Field";

import { useWindowSize       }  from "../../widget/windows/hooks";

import { GroupedData         ,
         ChartData           }  from "../../../dataTypes/dataSetManagment/regroupData";

import { Coordinate          } from '../../../dataTypes/geolocationManagment/types';

import { timeStepNames       } from '../../../dataTypes/timeManagment/utils';

type CustomerFrontEventListProps<T> = {
  startDate?             : string;
  endDate?               : string;
  filterName?            : string;
  timeStep?              : string;
  sessions               : T[];
  coords                 : Coordinate[];
  columns                : { header: string; accessor: keyof T }[];
  handleRefresh          : () => void;
  handleDateRangeChange  : (start: string, end: string) => void;
  handleTimeStepChange   : (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleFilterNameChange : (event: React.ChangeEvent<HTMLInputElement>, value: string | number | Date | File, duration?: string | undefined) => void;
  groupedData            : GroupedData<T>;
  chartData              : ChartData[];
  ready                  : boolean;
  renderRowDetails?      : (rowData: T) => React.ReactNode;
  barGraphTitle?         : string;
  barGraphSubTitle?      : string;
  height?                : string;
  showChart?             : boolean;
  showMap?               : boolean;
  showTable?             : boolean;
  channelChoices?        : string[];
};

export const CustomerFrontEventList = <T,> ({ startDate                  ,
                                              endDate                    ,
                                              filterName                 ,
											  timeStep                   ,
                                              sessions                   ,
                                              coords                     ,
                                              columns                    ,
                                              handleRefresh              ,
                                              handleDateRangeChange      ,
                                              handleTimeStepChange       ,
											  handleFilterNameChange     ,
                                              groupedData                ,
                                              chartData                  ,
                                              ready                      , 
                                              renderRowDetails           ,
                                              barGraphTitle    = ""      ,
                                              barGraphSubTitle = ""      ,
                                              height           = "100vh" ,
                                              showChart        = true    ,
                                              showMap          = true    ,
                                              showTable        = true    ,
                                              channelChoices   = []      }: CustomerFrontEventListProps<T>) => {


  const [ currentChannel     , setCurrentChannel     ] = useState(channelChoices[0]);

  const [  , setResultSectionWidth ] = useState(800);
  const [ chartWidth         , setChartWidth         ] = useState(800 * 0.6);
  const [ mapWidth           , setMapWidth           ] = useState(800 * 0.35);
  const [ localReady         , setLocalReady         ] = useState(false);

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    const newWidth = windowWidth - 200 || 800;
    setResultSectionWidth(newWidth);
    setChartWidth(newWidth * 0.6);
    setMapWidth(newWidth * 0.35);
    setLocalReady(true);
  }, [windowWidth]);


  const handleCurrentChannelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setCurrentChannel(e.target.value);
  };

  return (
  
    <div className = {styles.root} 
	     style     = {{ height }}>
		 
      <div className={styles.filterSection}>
        <div className={styles.filters}>
          {
		   channelChoices && 
		   channelChoices.length > 0 && 
		   (
            <WidgetFrame name               = "Chaine :"
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         classNameGrid      = {classNames(styles.grid_frame)} >
              <Select choices  = {channelChoices}
                      value    = {currentChannel}
                      onChange = {handleCurrentChannelChange} />
            </WidgetFrame>
           )
		  }
          <WidgetFrame name               = "Plage d'événements :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <DateTimeRangePicker onChange      = {handleDateRangeChange}
                                 showHourPanel = {true}
                                 labelColor    = "#000000"
                                 startDate     = {startDate}
                                 endDate       = {endDate} />
          </WidgetFrame>
		  
          <WidgetFrame name               = "Rechercher :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <Field type        = "text"
                   placeholder = ""
                   value       = {filterName}
                   onChange    = {handleFilterNameChange} />
          </WidgetFrame>
		  
          <WidgetFrame name               = "Echelle :"
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       classNameGrid      = {classNames(styles.grid_frame)} >
            <Select choices  = {timeStepNames}
                    value    = {timeStep}
                    onChange = {handleTimeStepChange} />
          </WidgetFrame>
        </div>
      </div>

      {
	   localReady && 
	   (
        sessions.length === 0 
		? 
		(
         <div className={styles.noDataMessage}>
           Aucune donnée à afficher pour la période considérée
         </div>
         ) 
		 : 
		 (
          <div className={styles.resultSection}>
            <div className={styles.dataDisplaySection}>
              {
			   showChart && 
			   (
                <div className={styles.chartSection}>
                  <ExtendablePanel width={chartWidth} height={mapWidth} logoUrl="/images/logo.png">
                    <CartesianGraph data               = {chartData}
                                    title              = {barGraphTitle}
                                    subTitle           = {barGraphSubTitle}
                                    colors             = {["#6717FF"]}
                                    titleFontSize      = {24}
                                    subTitleFontSize   = {21}
                                    xAxisLabelFontSize = {15}
                                    yAxisLabelFontSize = {15}
                                    legendFontSize     = {16}
                                    paddingTop         = {110}
                                    paddingBottom      = {100}
                                    paddingLeft        = {100}
                                    width              = {738}
                                    height             = {316}
                                    cumul              = {false}
                                    grapheType         = 'Bar'
                                    showLegend         = {false} />
                  </ExtendablePanel>
                </div>
               )
			  }
              {
			   showMap && 
			   (
                <div className= {styles.mapSection}>
                  <ExtendablePanel width        = {mapWidth} 
				                   height       = {mapWidth} 
								   logoUrl      = "/images/logo.png" 
								   logoPosition = "bottomLeft">
                    <OpenStreetMap coordinates = {coords} />
                  </ExtendablePanel>
                </div>
               )
			  }
            </div>
            {
		 	 showTable && 
			 (
              <div className={styles.tableSection}>
                <TabularDisplay groupedData = {groupedData} 
				                columns     = {columns} 
								rowDetailRenderer = {renderRowDetails} 
								groupDisplayOrder = 'reverse'
                                hideEmptyGroups   = {true} />
              </div>
             )
			}
          </div>
         )
       )
	  }
    </div>
  );
};

export default CustomerFrontEventList;
